import RadioButtonOrCheckbox from '../../Utils/RadioButtonOrCheckbox'
import { $red60 } from '../../../../../styles/colors/primitives'
import Text from '../../../../Text'
import { formatPrice } from '../../../../../utils/formats'
import {
  calculateDiscountFromRegularPriceCents,
  calculatePriceForMultipleShopItems
} from '../../../../../utils/shopItemsAndCart'
import React from 'react'
import styles from './styles.module.css'
import { addCentsToPrice } from '../../../../../utils/prices'

const cx = (...c) => c.filter(Boolean).join(' ')

function Offer({ items, onMouseOver, onMouseOut, isSelected, onClick, isOutOfStock, isNew, hideOutOfStockText }) {
  const name = items.map(i => i.name).join(', ')
  const description = items.length && items[0].shortConfigInfo

  const isUnavailable = items.some(i => i.availabilityStatus === 'UNAVAILABLE' || !i.price)

  const priceWithDiscount = calculatePriceForMultipleShopItems(items)
  const priceNoDiscount = addCentsToPrice(priceWithDiscount, calculateDiscountFromRegularPriceCents(items))

  const hasDiscount = !!priceNoDiscount && !!priceWithDiscount && priceWithDiscount.priceCents !== priceNoDiscount.priceCents

  let outOfStockText = 'Out of stock'
  if (isUnavailable) {
    outOfStockText = 'Not available'
  } else if (items.some(i => i.availabilityStatus === 'SOLD_OUT')) {
    outOfStockText = 'Sold out'
  } else if (isNew) {
    outOfStockText = 'Coming soon'
  }

  const disabled = isOutOfStock || isUnavailable

  return (
    <div className={cx(styles.offerWrapper, isSelected && styles.offerWrapperSelected, disabled && styles.offerWrapperDisabled)} onClick={onClick} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
      <div className={styles.offerTitleAndDescription}>
        <div className={styles.offerTitle}>
          {
            !(isOutOfStock || isUnavailable) && <RadioButtonOrCheckbox
              isSelected={isSelected}
              checkboxStyle={false}
              checkedColor={$red60}
            />
          }
          <Text type="small">{name}</Text>
        </div>
        { description && <Text type="tiny">{description}</Text> }
      </div>
      <div className={styles.priceWrapper}>
        { !isUnavailable && (
          <>
            <div className={cx(styles.regularPrice, hasDiscount && styles.regularPriceDiscounted)}><Text type="regular">{formatPrice(priceNoDiscount)}</Text></div>
            <div className={cx(styles.discountPrice, !hasDiscount && styles.discountPriceHidden)}><Text type="heading-6">{formatPrice(priceWithDiscount)}</Text></div>
          </>
        )}
        { (isOutOfStock || isUnavailable) && !hideOutOfStockText && <Text type="tiny">{outOfStockText}</Text> }
      </div>
    </div>
  )
}

export default Offer
